import { useState, useEffect } from 'react';
import api from "../../../../services/api";

/**
 * 아카이브 > 회고록 > 상세
 * 회고록 상세 (목차) api 호출 hook
 */
const useApiByDetail = (book_id) => {
    const [data, setData] = useState([]);
    const [totalCount, setTotal] = useState(0);

    useEffect(() => {
        // API 호출
        const fetchBiographyDetails = async () => {
            try {
                const response = await api.get(`/get_book_and_tocs_with_paragraphs_by_book_id/${book_id}`);
                if (response?.data?.data === false) {
                    throw new Error("Invalid response format");
                }

                const item = response.data.data;

                const formattedData = {
                    book_info: {
                        book_id: item.book_info.book_id,
                        authors: item.book_info.authors,
                        book_title: item.book_info.book_title,
                        numeration: item.book_info.numeration,
                        publish_year: item.book_info.publish_year,
                        publisher: item.book_info.publisher,
                        library: item.book_info.library,
                        url: item.book_info.url,
                        book_category: item.book_info.book_category,
                        authors_ko: item.book_info.authors_ko,
                        book_title_ko: item.book_info.book_title_ko,
                        publish_date: item.book_info.publish_date,
                        publisher_ko: item.book_info.publisher_ko,
                        note: item.book_info.note,
                        n_tocs: item.book_info.n_tocs
                    },
                    tocs: item.tocs.map((toc) => ({
                        toc_id: toc.toc_id,
                        book_id: toc.book_id,
                        toc_hierarchy: toc.toc_hierarchy,
                        toc_order: toc.toc_order,
                        toc_title: toc.toc_title,
                        toc_title_ko: toc.toc_title_ko,
                        page_start: toc.page_start,
                        n_records: toc.n_records
                    }))
                };

                formattedData.tocs.sort((a, b) => parseInt(a.page_start) - parseInt(b.page_start));
                setData(formattedData);
                setTotal(formattedData.length);
            } catch (error) {
                console.error("Failed to fetch book details", error);
            }
        };

        fetchBiographyDetails();
    }, [book_id]);

    return data;
};

export default useApiByDetail;
